
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 12.335C22 17.855 17.52 22.335 12 22.335C6.48 22.335 2 17.855 2 12.335C2 6.81496 6.48 2.33496 12 2.33496C17.52 2.33496 22 6.81496 22 12.335Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.7099 15.5147L12.6099 13.6647C12.0699 13.3447 11.6299 12.5747 11.6299 11.9447V7.84473","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.49984 23.4181C8.03114 23.4181 10.0832 21.3661 10.0832 18.8348C10.0832 16.3035 8.03114 14.2515 5.49984 14.2515C2.96853 14.2515 0.916504 16.3035 0.916504 18.8348C0.916504 21.3661 2.96853 23.4181 5.49984 23.4181Z","fill":"white","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.97461 19.903C3.97461 20.4942 4.42836 20.9709 4.99211 20.9709H6.14253C6.63294 20.9709 7.03169 20.5538 7.03169 20.0405C7.03169 19.4813 6.78878 19.2842 6.42669 19.1559L4.57961 18.5142C4.21753 18.3859 3.97461 18.1888 3.97461 17.6296C3.97461 17.1163 4.37336 16.6992 4.86378 16.6992H6.01419C6.57794 16.6992 7.03169 17.1759 7.03169 17.7671","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.5 16.085V21.585","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    